/**
 * Research 화면의 값 — 갈래 탭.
 *
 * 갈래마다 **이미 있는 조사 화면**을 그대로 물린다 — 소셜 통합 검색 · 광고 소재 조사 ·
 * 상품 정보 조사 · 이벤트 캘린더.
 * 물린 화면의 제목은 접는다 — 이 화면의 머리(구역 · 갈래 이름)가 제목을 쥔다.
 */

import type { ManualId } from 'src/types/manual/manual-domain';

/** 분석 갈래 */
export const ANALYSIS_TABS = ['social', 'ads', 'products', 'events'] as const;
export type AnalysisTab = (typeof ANALYSIS_TABS)[number];

export const ANALYSIS_TAB_LABELS: Record<AnalysisTab, string> = {
  social: '소셜 게시물',
  ads: 'Meta 광고',
  products: '판매몰 상품',
  events: '이벤트 캘린더',
};

export const ANALYSIS_TAB_ICONS: Record<AnalysisTab, string> = {
  social: 'solar:chat-square-like-linear',
  ads: 'solar:gallery-wide-linear',
  products: 'solar:bag-4-linear',
  events: 'solar:calendar-mark-linear',
};

/**
 * 탭마다 그 갈래의 매뉴얼 — 머리의 「사용 가이드」는 **지금 탭**의 것을 연다.
 * `null` 이면 그 탭에서는 「사용 가이드」가 서지 않는다(매뉴얼이 생기면 id 한 줄로 켠다).
 */
export const ANALYSIS_TAB_MANUALS: Record<AnalysisTab, ManualId | null> = {
  social: 'search',
  ads: 'meta-ads',
  products: 'market',
  events: 'event-calendar',
};
